<template>
  <div>
    Reported Messages
    <button @click="load()">Reload / Refresh</button>
    <ul>
      <li class="list" :key="rMSG._id" v-for="rMSG in msgs">
        Room: <a target="_blank" :href="`https://yoteachapp.com/${rMSG.roomTitle}`">{{ rMSG.roomTitle }}</a>
        <br />
        <span>
          Sent By This Person: {{ rMSG.senderName }}
          <br />
          From this DeviceID: {{ rMSG.senderUUID }}
          <br />
        </span>
        <a v-if="rMSG.imgURL" target="_blank" :href="rMSG.imgURL">
          <img class="img-reported" :src="rMSG.imgURL" alt="">
        </a>
        <span v-else>
          Message: {{ rMSG.messageText }}
        </span>
        <br />
        <button @click="rMSG.viewDetail = !rMSG.viewDetail; $forceUpdate()">View / Hide Details</button>
        <button v-if="!rMSG.isMuted" @click="muteThisGuy({ report: rMSG, roomID: rMSG.roomID, messageID: rMSG.messageID })">Mute this person</button>
        <button v-if="rMSG.isMuted" @click="unmuteThisGuy({ report: rMSG, roomID: rMSG.roomID, messageID: rMSG.messageID })">Unmute this person</button>
        <button @click="removeItem({ report: rMSG, roomID: rMSG.roomID, messageID: rMSG.messageID })">Delete Message & Report Record</button>
        <br />
        <pre v-if="rMSG.viewDetail">{{ rMSG }}</pre>
        <!-- <button @click="showChat({ roomID: rMSG.roomID })">Show ChatRoom</button> -->
      </li>
    </ul>
  </div>
</template>

<script>
import * as API from '../parts/YoNetwork/YoNetwork.js'
import * as eAPI from '../SubCompos/eAPI.js'
export default {
  eAPI,
  API,
  props: {
    earthID: {},
    userID: {}
  },
  data () {
    return {
      msgs: [],
      earthSecrets: false,
      ready: false
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    showChat ({ roomID }) {
      this.$emit('showChat', { roomID })
    },
    async removeItem ({ report, roomID, messageID }) {
      if (!window.confirm('Do you want to remove message?')) {
        return
      }
      await API.removeMessage({
        roomID: roomID,
        roomAdminPassword: this.earthSecrets.earthPassword,
        msg: report.msgRaw
      })
      await eAPI.removeReport({ reportID: report._id, userID: report.userID, earthID: report.userID })
      this.load()
    },
    async muteThisGuy ({ report, roomID, messageID }) {
      await API.addMute({
        roomID: roomID,
        roomAdminPassword: this.earthSecrets.earthPassword,
        uuid: report.msgRaw.senderUUID
      }).then(async (resp) => {
        console.log(resp.data)
        API.roomChanged(resp.data)

        let roomResp = await API.getRoom({ _id: report.roomID })
        report.isMuted = roomResp.data.mutedUUIDs.includes(report.msgRaw.senderUUID)
        this.$forceUpdate()
        window.alert('muted this guy')
      })
    },
    async unmuteThisGuy ({ report, roomID, messageID }) {
      await API.removeMute({
        roomID: roomID,
        roomAdminPassword: this.earthSecrets.earthPassword,
        uuid: report.msgRaw.senderUUID
      }).then(async (resp) => {
        console.log(resp.data)
        API.roomChanged(resp.data)

        let roomResp = await API.getRoom({ _id: report.roomID })
        report.isMuted = roomResp.data.mutedUUIDs.includes(report.msgRaw.senderUUID)
        this.$forceUpdate()
        window.alert('Unmuted this guy')
      })
    },
    async load () {
      this.msgs = await eAPI.listReportedMessages({ userID: this.userID, earthID: this.earthID })
      this.msgs.forEach(async (rMSG) => {
        let roomResp = await API.getRoom({ _id: rMSG.roomID })
        rMSG.isMuted = roomResp.data.mutedUUIDs.includes(rMSG.msgRaw.senderUUID)
        this.$forceUpdate()

        API.onRoomChange({
          roomID: rMSG.roomID,
          update: async () => {
            let roomResp = await API.getRoom({ _id: rMSG.roomID })
            rMSG.isMuted = roomResp.data.mutedUUIDs.includes(rMSG.msgRaw.senderUUID)
            this.$forceUpdate()
          },
          onClearRoom: () => {
          },
          goHome: () => {
          }
        })
      })
      let arr = await eAPI.getEarthSecret({ userID: this.userID, earthID: this.earthID })
      this.earthSecrets = arr[0]
      this.ready = true
    }
  }
}
</script>

<style scoped>
.img-reported{
  border: #eee solid 1px;
  padding: 10px;
  margin: 10px;
  max-width: 100px;
  max-height: 100px;
}
.list{
  border-bottom: black solid 3px;
  padding-bottom: 20px;
  margin-bottom: 30px;
  display: block;
  list-style: circle;
}
</style>
